<template>
    <AppLayoutBase>
        <template slot="main">
            <HomeContent/>
        </template>

        <template slot="navbar">
            <AppLayoutNavbar>
                <template slot="apps">
                    <div></div>
                </template>
            </AppLayoutNavbar>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped>

</style>